export default (function () {

    var routes = [];

    return {
        add: function (route, cb) {
            routes.push({ route: route, rmt: new RegExp('^' + route + '$', ''), fn: cb });
            if (routes.length == 1) {
                // init
                window.addEventListener('popstate', function (e) {
                    url = window.location.pathname;
                    Router.go(url, false);
                });
            }
        },

        go: function (path, hist) {
            for (var i = 0; i < routes.length; i++) {
                var rt = routes[i].rmt.exec(path);
                if (rt !== null) {

                    // call the page
                    routes[i].fn(hist, rt);

                    // dont try further
                    return;
                }
            }
        },

        hpush: function (path) {
            // change url
            history.pushState({
                path: path
            }, null, path);
        },

        hinit: function (path) {
            // initialize history
            history.replaceState({
                path: path
            }, null, path);
        }
    };

})();
